import { CheckBoxWrapper, CheckText, InputContainer } from 'routes/Report/styles';
import { FilterDropdown, OptionsFormat, ReportFilter } from 'models/report';
import { ExecReportPayload } from 'models/request';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Checkbox from 'components/Buttons/CheckboxButton';
import Dropdown from 'components/Input/dropdown/Dropdown';
import Modal from 'components/Modal';
import actions from 'state/actions';
import selectors from 'state/selectors';
import services from 'services';
import styled from 'styled-components/macro';
import utils from 'utils';

const InputContainerCenter = styled(InputContainer)`
  justify-content: flex-end;
`;
const WrapperExportReportOptions = styled.div`
  margin-top: 28px;
`;

export default () => {
  const t = utils.intl.useTranslator();
  const [format, setFormat] = useState<FilterDropdown | null>({ label: 'xlsx', value: 'XLSX' });
  const [isNotify, setIsNotify] = useState(false);
  const modalProps: { payload: ExecReportPayload; csvFormat?: boolean } = useSelector(selectors.modal.getModalProps);
  const selectedFilterPreference = useSelector(selectors.userReportSettings.getSelectedFilterPreference);
  const { payload, csvFormat } = modalProps || {};
  const { execReport } = services;

  const dispatch = useDispatch();

  const optionsFormat: OptionsFormat[] = csvFormat
    ? [
        {
          label: 'csv',
          value: 'CSV',
          contentType: 'application/csv',
        },
      ]
    : [
        {
          label: 'csv',
          value: 'CSV',
          contentType: 'application/csv',
        },
        {
          label: 'xlsx',
          value: 'XLSX',
          contentType: 'application/excel',
        },
      ];

  const handleConfirm = async () => {
    const filteredPayload = payload.queryReportInfo.filters.filter(
      ({ listOfValues }: ReportFilter) => listOfValues && listOfValues?.length > 0,
    );

    const sendPayload: ExecReportPayload = {
      ...payload,
      async: isNotify,
      outputFormat: format?.value ?? optionsFormat[0].value,
      queryReportInfo: {
        ...payload.queryReportInfo,
        filters: filteredPayload,
      },
      idUserReportSetting: selectedFilterPreference?.idUserReportSetting || null,
    };
    try {
      const { data } = await execReport(sendPayload);
      if (!isNotify) {
        const extension = optionsFormat.find(({ value }) => value === format?.value)?.value.toLowerCase();
        const filename = `report_${new Date().getTime()}`;
        utils.file.downloadFileFromBase64Source(
          filename,
          data.file,
          optionsFormat.find(({ value }) => value === format?.value)?.contentType.toString() || '',
          extension,
        );
        dispatch(actions.modal.closeModal());
      } else {
        utils.app.notify('success', t('report-async-success'));
        dispatch(actions.modal.closeModal());
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onChangeFormat = (format: any) => {
    setFormat(format);
  };

  return (
    <>
      <Modal.Header title={t('report-export-title')} subtitle={t('report-export-description')} />
      <Modal.Content>
        <WrapperExportReportOptions>
          <InputContainerCenter>
            <label>{t('report-label-fileformat')}</label>
            <Dropdown
              id="format-dropdown"
              value={format}
              onChange={onChangeFormat}
              name="format"
              options={optionsFormat}
              disabled={optionsFormat.length === 1}
            />
          </InputContainerCenter>
          <CheckBoxWrapper>
            <Checkbox
              action={(checked) => {
                setIsNotify(checked);
              }}
              name="notify"
              isActive={isNotify}
            />
            <CheckText>{t('report-export-notify-label')}</CheckText>
          </CheckBoxWrapper>
        </WrapperExportReportOptions>
      </Modal.Content>
      <Modal.Footer confirmAction={handleConfirm} />
    </>
  );
};
